import { render, staticRenderFns } from "./CollectorLogsSubPanel.vue?vue&type=template&id=dea1d74e"
import script from "./CollectorLogsSubPanel.vue?vue&type=script&lang=js"
export * from "./CollectorLogsSubPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/disk1/buildAgent/work/ffa2b6072150c7f8/vAnalyticsJS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dea1d74e')) {
      api.createRecord('dea1d74e', component.options)
    } else {
      api.reload('dea1d74e', component.options)
    }
    module.hot.accept("./CollectorLogsSubPanel.vue?vue&type=template&id=dea1d74e", function () {
      api.rerender('dea1d74e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/modules/admin/components/Logs/CollectorLogsSubPanel.vue"
export default component.exports